import * as React from 'react';
import { classNames } from '@features/utils/reactFunctions';
import * as elements from '@appStyles/_elements.module.scss';

import * as style from '../../CelsiusClaimPageStyles.module.scss'

type Props = {
  handleImportFunds: () => void;
  rejectionReason?: string;
};

export const RejectedState = ({ handleImportFunds, rejectionReason }: Props) => (
  <div className={style.headerWrapperPadding}>
    <h1 className={style.headerTitle}>Your request has been rejected</h1>
    <p className={style.headerText}>
      {rejectionReason}
    </p>
    <button
      className={classNames(elements.btn, style.actionButton)}
      onClick={handleImportFunds}
    >
      Resubmit
    </button>
  </div>
);
